export default "__VITE_ASSET__liglnSk0__"